<div class="flex flex-1 mt-2 mb-3" *ngIf="this.context.writePermission">
    <div class="p-input-icon-left flex-1" id="searchBarContainer">
        <i class="ml-1 far fa-magnifying-glass"></i>
        <input type="text" class="w-12" pInputText id="searchBar" (keyup)="onSearchBarKeyUp($event.target)" />
    </div>

    <span class="p-buttonGroup">
        <p-button [dt]="showPushDialog? whiteButtonActive : whiteButton" (click)="showPushDialog=!showPushDialog"
            icon="far fa-send" class="ml-1 pushnotificationButton" *ngIf="currentEventSignUps.length > 0"
            [class.buttonActive]="showPushDialog" ariaLabel="Send push notification"
            i18n-ariaLabel="@@appointment-management-list.buttons.sendPushNotification"></p-button>


        <p-button [dt]="whiteButton" class="ml-1 excelButton" (click)="onExportToExcel()" icon="far fa-file-excel"
            ariaLabel="Export to excel" i18n-ariaLabel="@@appointment-management-list.buttons.exportToExcel"></p-button>

        <p-button [dt]="whiteButton" class="ml-1 qrScannerButton" (click)="openQRCodeScanner()" icon="far fa-handshake"
            *ngIf="event.issueTicketsUponRegistration" ariaLabel="Scan ticket via QR code"
            i18n-ariaLabel="@@appointment-management-list.buttons.scanTicketViaQRcode"></p-button>

        <p-button [dt]="viewControl.registrationVisible ? whiteButtonLastActive : whiteButtonLast"
            class="ml-1 addButton" *ngIf="canWrite"
            (click)="viewControl.registrationVisible = !viewControl.registrationVisible" icon="far fa-plus"
            ariaLabel="Add participants"
            i18n-ariaLabel="@@appointment-management-list.buttons.addParticipants"></p-button>
    </span>
</div>

<div class="push-notification p-3 mb-3" *ngIf="showPushDialog && currentEventSignUps.length > 0" id="sendPushDialog">
    <div class="font-semibold" i18n="@@event-sign-ups-overview.push-title">Send push message</div>
    <div class="my-2" i18n="@@event-sign-ups-overview.push-placeholder">The message will be sent to all participants in
        the list.</div>
    <label for="pushMessage" class="sr-only" i18n="@@event-sign-ups-overview.push.label">Push message</label>
    <textarea pInputTextarea class="block w-full" [rows]="3" [autoResize]="true" id="pushMessage" [maxLength]="2000"
        #pushMessage></textarea>

    <div class="text-right">
        <button pButton type="button" class="mt-2 p-button-secondary sendButton" label="Send message"
            i18n-label="@@event-sign-ups-overview.push.send" (click)="onSendPushNotification(pushMessage)"
            [disabled]="pushMessage.value.length == 0" [ariaDisabled]="pushMessage.value.length == 0"></button>
    </div>
</div>

<p-panel *ngIf="viewControl.registrationVisible" id="addParticipantDialog">
    <ng-template pTemplate="header">
        <div class="w-full">
            <div class="font-semibold" i18n="@@event-sign-ups-register.component.header">Add participant</div>
        </div>

    </ng-template>
    <form [formGroup]="registrationForm" id="registrationForm">
      
            <div class="flex-1 attendeeFirstname">
                <label for="firstname" i18n="@@event-sign-ups-register.component.input.firstName">First name *</label>
                <input pInputText type="text" class="inputfield w-full" formControlName="firstname" autofocus id="firstname">
            </div>
            <div class="errorText"
                *ngIf="registrationForm.get('firstname').invalid && (registrationForm.get('firstname').dirty || registrationForm.get('firstname').touched)">
                <small class="form-text p-error" i18n="@@event-sign-ups-register.component.firstNameError"
                    *ngIf="registrationForm.get('firstname').errors.required" id="FirstNameError">First name required</small>
            </div>

            <div class="mt-3 flex-1 attendeeName">
                <label for="name" i18n="@@event-sign-ups-register.component.input.name">Name *</label>
                <input pInputText type="text" class="inputfield w-full" formControlName="name" id="name">
            </div>
            <div class="errorText"
                *ngIf="registrationForm.get('name').invalid && (registrationForm.get('name').dirty || registrationForm.get('name').touched)">
                <small class="form-text p-error" i18n="@@event-sign-ups-register.component.nameError"
                    *ngIf="registrationForm.get('name').errors.required" id="nameError">Name required</small>
            </div>
 
        <div class="mt-3 attendeeEmail">
            <label for="email" i18n="@@event-sign-ups-register.component.input.email">Email</label>
            <input pInputText type="text" class="inputfield w-full" formControlName="email" id="email">
        </div>

        <div class="mt-3 attendeePhone">
            <label for="phone" i18n="@@event-sign-ups-register.component.input.phone">Phone number</label>
            <input pInputText type="text" class="inputfield w-full" formControlName="phoneNumber" id="phone">
        </div>
        <div class="mt-3 attendeeComment">
            <label for="comment" i18n="@@event-sign-ups-register.component.input.comment">Comment</label>
            <textarea pInputTextarea id="comment" class="block w-full" rows="3" [autoResize]="true"
                formControlName="comment" id="comment" inputId="comment">
            </textarea>
        </div>
        <div class="text-right mt-3 mb-2">
            <p-button styleClass="p-button-secondary" label="Add participant"
                i18n-label="@@event-sign-ups-register.component.input.add-participant" class="submitButton"
                (onClick)="onAddParticipant()"></p-button>
        </div>
    </form>
</p-panel>

<div class="w-full signupSort" *ngIf="this.context.writePermission">
    <p-select [options]="signUpSortingOptions" optionLabel="label" optionValue="id" [(ngModel)]="activeSorting"
        (onChange)="onApplyFilter()" dataKey="id" autoWidth="false" [style]="{ width: '100%' }"
        ariaLabel="Sorting options" i18n-ariaLabel="@@event-sign-ups-register.component.sortingOptions">
    </p-select>
</div>


<div class="font-semibold mt-2 mb-2 participantNumbers">
    <ng-container *ngIf="viewControl.signups>0">
        <span class="signupNumber">{{viewControl.signups}} <span
                i18n="@@event-sign-ups-overview.participants">Participants</span></span>
    </ng-container>

    <ng-container *ngIf="viewControl.waitingList>0">
        <span *ngIf="viewControl.signups > 0">,</span>

        <span class="waitinglistNumber">{{viewControl.waitingList}} <span
                i18n="@@event-sign-ups-overview.wating-list">On waiting list</span></span>
    </ng-container>

</div>

<ng-container *ngIf="currentEventSignUps">
    <div *ngFor="let signUp of currentEventSignUps; let i = index">

        <div class="flex mt-2 align-items-center" id="{{signUp.id}}">
            <div class="flex flex-column flex-1 p-3 md:p-4 w-full eventSignupAttendeeWrapper">
                <div class="flex flex-column justify-content-between md:flex-row">
                    <div class="flex">
                        <div class="flex align-items-center mr-2 md:mr-2">
                            <img *ngIf="currentEventSignUps[i].seat.userProfileId"
                                [src]="apiURL + '/file-api/userprofile/image/' + currentEventSignUps[i].seat.userProfileId + '?thumbnail=true&access_token=' + coreService.getJWTToken()"
                                class="shadow-none w-full profileImage mr-2"
                                style="border-radius: 6px; object-fit: cover;max-width:5rem;" role="presentation" alt=""/>
                        </div>

                        <div class="flex flex-column signupDate" style="word-break: break-all;">
                            <div class="ml-2 md:ml-4" *ngIf="!currentEventSignUps[i].seat.userProfileId"></div>
                            <div class="ml-2 mb-2">
                                {{ signUp.creationDate | date:'medium' }}
                            </div>

                            <div class="ml-2 font-semibold attendeeFullname">
                                {{currentEventSignUps[i].seat.firstname}}
                                {{currentEventSignUps[i].seat.name}}
                            </div>
                            <div class="signupStatus">
                                <div class="ml-2 mt-2 reserved" *ngIf="currentEventSignUps[i].status === 'RESERVED'">
                                    <p-tag value="Reserved" i18n-value="@@event-sign-ups-overview.status.reserved"
                                        severity="info"></p-tag>
                                </div>
                                <div class="ml-2 mt-2 waitinglist" *ngIf="currentEventSignUps[i].status === 'QUEUED'">
                                    <p-tag value="Wating list Position {{currentEventSignUps[i].waitingPosition}}"
                                        i18n-value="@@event-sign-ups-overview.statuswaiting-list-position"
                                        severity="warning"></p-tag>

                                </div>
                            </div>
                            <div class="ml-2 mt-2 flex align-items-center attendeeEmail" *ngIf="canWrite">
                                <i class="far fa-envelope mr-1" aria-hidden="true"></i> <span
                                    aria-hidden="true">:</span>
                                <a (click)="onMailTargetClient(currentEventSignUps[i].seat.email)"
                                    class="ml-1 cursor-pointer font-semibold" aria-label="Contact participant via email"
                            i18n-aria-label="@@appointment-management-list.contactParticipantsViaEmail">
                                    {{currentEventSignUps[i].seat.email}}
                                </a>
                            </div>
                            <div class="ml-2 mt-2 flex align-items-center attendeePhone"
                                *ngIf="currentEventSignUps[i].seat.phoneNumber && currentEventSignUps[i].seat.phoneNumber.length && canWrite">
                                <i class="far fa-phone mr-1" aria-hidden="true"></i> <span
                                    aria-hidden="true">:</span>
                                <a (click)="onPhoneTargetClient(currentEventSignUps[i].seat.phoneNumber)"
                                    class="ml-1 cursor-pointer font-semibold" aria-label="Contact participant via phone"
                            i18n-aria-label="@@appointment-management-list.contactParticipantsViaPhone">
                                    {{currentEventSignUps[i].seat.phoneNumber}}
                                </a>
                            </div>
                            <div class="ml-2 mt-2 flex align-items-center attendeeChat"
                                *ngIf="signUp.seat.userProfileId && coreService.isNativeApp()">
                                <i class="far fa-message-lines mr-1" aria-hidden="true"></i> <span
                                    aria-hidden="true">:</span>
                                <a (click)="onOpenChatWithUser(signUp.seat.userProfileId)"
                                    class="ml-1 cursor-pointer font-semibold"
                                    i18n="@@event-sign-ups-overview.directchat" aria-label="Start direct chat with participant"
                            i18n-aria-label="@@appointment-management-list.startDirectChatWithParticipant">
                                    Direct chat
                                </a>
                            </div>
                        </div>

                    </div>
                    <div class="flex justify-content-between">
                        <div class="flex flex-column justify-content-center mt-2 md:mt-0">
                            <!-- <div class="m-2" *ngIf="signUp.seat.email && signUp.seat.email!=''">
                                <button pButton class="p-button-info p-2" icon="far fa-envelope"
                                    (click)="onMailTargetClient(currentEventSignUps[i].seat.email)"></button>
                            </div> -->
                            <ng-container
                                *ngIf="this.context.writePermission && (signUp.status ==='CONFIRMED' || signUp.status ==='ATTENDED')">
                                <div class="eventSignUpsToggleButtons" *ngIf="event.manageAttendees">
                                    <p-button class=" p-2 confirmAttendanceButton" icon="far fa-handshake"
                                        (click)="confirmEventAttendance(signUp)" label="Presence not confirmed"
                                        i18n-label="@@event-sign-ups-overview.AttendanceNotConfirmed" severity="danger"
                                        *ngIf="signUp.status === 'CONFIRMED'" [text]="true"></p-button>
                                    <p-button class="p-2 rejectAttendanceButton" icon="far fa-handshake"
                                        (click)="rejectEventAttendance(signUp)" label="Attendance confirmed"
                                        i18n-label="@@event-sign-ups-overview.AttendanceConfirmed" severity="success"
                                        *ngIf="signUp.status === 'ATTENDED'" [text]="true"></p-button>
                                </div>
                                <div class="eventSignUpsToggleButtons" *ngIf="event.paymentDocumentation">
                                    <p-button class="p-2 confirmPaymentButton" icon="far fa-euro-sign"
                                        (click)="confirmEventPayment(signUp)" label="Payment not confirmed"
                                        i18n-label="@@event-sign-ups-overview.PaymentNotConfirmed" severity="danger"
                                        *ngIf="signUp.payed == false" [text]="true"></p-button>
                                    <p-button class="p-2 rejectPaymentButton" icon="far fa-euro-sign"
                                        (click)="rejectEventPayment(signUp)" label="Payment confirmed"
                                        i18n-label="@@event-sign-ups-overview.PaymentConfirmed" severity="success"
                                        *ngIf="signUp.payed == true" [text]="true"></p-button>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="this.context.writePermission && signUp.status === 'QUEUED'">
                                <div class="eventSignUpsToggleButtons">
                                    <p-button class="p-2 removeFromQueueButton" icon="far fa-check"
                                        (click)="dequeueCalendarEventRegistration(signUp)" label="Register directly"
                                        i18n-label="@@event-sign-ups-overview.register-directly"
                                        [text]="true"></p-button>
                                </div>

                            </ng-container>

                        </div>

                        <div class="mr-2 flex align-items-center ml-2 md:ml-4">
                            <p-button *ngIf="this.context.writePermission" class="p-2 deleteSignupButton" [text]="true"
                                severity="danger" icon="far fa-trash" (click)="onClickCancelSignUp(signUp)" aria-label="Delete participant"
                            i18n-aria-label="@@appointment-management-list.deleteParticipant"></p-button>
                        </div>

                    </div>
                </div>

                <div class="flex mt-4 registeredBy"
                    *ngIf="currentEventSignUps[i].client && currentEventSignUps[i].client.name != currentEventSignUps[i].seat.name">
                    <div class="ml-2 mb-2 text-sm font-light">
                        <span i18n="@@event-sign-ups-overview.registered-by">Registered by</span>
                        {{currentEventSignUps[i].client.name}} (
                        <a href="mailto:{{currentEventSignUps[i].client.email}}" class="font-semibold">
                            {{currentEventSignUps[i].client.email}}
                        </a>
                        )
                    </div>
                </div>

                <div class="horizontalSeperator"
                    *ngIf="(event.registrationForm && currentEventSignUps[i].formData) || currentEventSignUps[i].seat.comment">
                </div>

                <div class="flex flex-column mt-2 text-sm"
                    *ngIf="(event.registrationForm && currentEventSignUps[i].formData) || currentEventSignUps[i].seat.comment || currentEventSignUps[i].ticket">

                    <div *ngIf="currentEventSignUps[i].seat.comment"
                        class="flex flex-column md:flex-row attendeeComment">
                        <div i18n="@@event-sign-ups-overview.comment" class="w-full md:w-7rem font-semibold">Comment:
                        </div>
                        <div class="ml-0 md:ml-2 w-full md:w-10">
                            {{currentEventSignUps[i].seat.comment}}
                        </div>
                    </div>

                    <ng-container *ngIf="currentEventSignUps[i].ticket as ticket">
                        <div class="w-full md:w-5rem flex flex-column my-2">
                            <div i18n="@@event-sign-ups-overview.ticket" class="font-semibold">Ticket:</div>
                            @if(ticket.product){
                            <div>{{ticket.product.name}}</div>
                            <div>
                                <span>{{ticket.product.price.amount / 100 | currency:
                                    ticket.product.price.currency.toUpperCase()}}</span>
                            </div>
                            }
                        </div>
                    </ng-container>

                    <ng-container *ngIf="event.registrationForm">
                        <div *ngFor="let field of event.registrationForm.fields"
                            class="flex flex-column md:flex-row mt-2 attendeeDynamicFields">
                            <ng-container
                                *ngIf="currentEventSignUps[i].formData && currentEventSignUps[i].formData[field.propertyName]!=null">
                                <div class="w-full md:w-7rem font-semibold">{{field.columnName}}:</div>
                                <div class="ml-0 md:ml-2 w-full md:w-10"><span *ngIf="field.datatype ==='BOOLEAN'"><i
                                            class="far fa-check"
                                            *ngIf="currentEventSignUps[i].formData[field.propertyName] ==true"></i><i
                                            class="far fa-times"
                                            *ngIf="currentEventSignUps[i].formData[field.propertyName] == false"></i></span><span
                                        *ngIf="field.datatype !=='BOOLEAN'">{{currentEventSignUps[i].formData[field.propertyName]}}</span>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

    </div>
    <div *ngIf="currentEventSignUps.length == 0" class="noAtetndeesHintText">
        <p i18n="@@event-sign-ups-overview.component.text.noSignUpsForThisEvent">There are no registrations for the
            selected
            event.</p>
    </div>
</ng-container>

<!---- AdminSignUp Modal
<p-dialog [focusOnShow]="false" header="Title" modal="true" [(visible)]="displayAdminSignUp" *ngIf="displayAdminSignUp" [draggable]="false" [style]="{width: '90%'}">
    <lib-event-registration (closeEventRegistration)="onUpdateAfterAdminSignUp()"
    [event]="event"></lib-event-registration>

</p-dialog>-->

<!--Löschbestätigung für Reservierung-->
<p-dialog [focusOnShow]="false" header="Cancel Sign-Up"
    i18n-header="@@event-sign-ups-overview.component.dialog.headerCancelSignUp"
    [(visible)]="showCancelEventSignUpConfirm" [modal]="true" [draggable]="false" [dismissableMask]="true"
    [focusTrap]="true" closeAriaLabel="Close" i18n-closeAriaLabel="@@event-sign-ups-overview.component.dialog.Close"
    id="cancelSignupDialog" (onShow)="onModalShow('cancelSignupDialog')" [resizable]="false" id="cancelSignupDialog"
    class="height: 90%">
    <p i18n="@@event-sign-ups-overview.component.text.eventSignUps">Do you really want to cancel the selected
        registration
        for this event?</p>

    <p-button type="button" i18n="@@event-sign-ups-overview.component.button.cancelYes" label="Yes"
        (click)="cancelUserSignUp(this.currentEventSignUpID)" icon="far fa-check"
        class="p-button-danger deleteSignUpButton"></p-button>
    <p-button type="button" i18n="@@event-sign-ups-overview.component.button.cancelNo" label="No" class="cancelButton"
        (click)="null" icon="far fa-ban"></p-button>
</p-dialog>